import {
  DarkWebHeader,
  DarkWebFindOutWhatElse,
  DarkWebBreaches,
  Faq,
  useSession,
  SerializedDarkWebBreach,
  useDarkWebReport,
  SearchData,
  ReportLoading,
} from '@ltvco/refresh-lib/v1';
import { darkWebScanFaq } from './darkWebScanConstants';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export function DarkWebScan() {
  const {
    session: { account },
  } = useSession();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Dark Web Scan - NumberGuru';
  }, []);

  const { data, isLoading } = useDarkWebReport({
    email: account?.account.user_info?.email as string,
  });

  if (isLoading) return <ReportLoading />;

  const breaches = data?.data?.breaches;
  const updatedAt = data?.data?.rawData?.meta?.updated_at;

  return (
    <>
      <DarkWebHeader updatedAt={updatedAt || ''} />
      <DarkWebBreaches breaches={breaches as SerializedDarkWebBreach[]} />
      <DarkWebFindOutWhatElse
        onSuccess={({ reportType, searchParams, permalink }: SearchData) => {
          const url = `/report/${reportType}?${searchParams}&permalink=${permalink}`;
          navigate(url);
        }}
      />
      <Faq faqItems={darkWebScanFaq} />
    </>
  );
}
